import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { styled, useTheme } from '@mui/material/styles';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';
import { UiButton, UiIcon } from 'ui-components';
import { getEnv } from 'utils';
import { useOnClickOutside } from 'hooks';

const StyledChatwoot = styled('div')(
  ({ theme, isSidebarMenuExpanded }) => css`
    height: 45px;

    .MuiButton-root {
      width: 100%;
      height: 100%;
      justify-content: start;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }

    .icon {
      margin: ${theme.direction === 'rtl' ? '0 17px 0 8px' : '0 8px 0 17px'};
    }

    ${!isSidebarMenuExpanded &&
    css`
      .MuiButton-root {
        .text {
          display: none;
        }
      }
    `}
  `
);

export function ChatwootWidget() {
  const { t } = useTranslation();
  const isSidebarMenuExpanded = useSelector(
    (state) => state.pageReducer.isSidebarMenuExpanded
  );
  const theme = useTheme();
  const ref = useRef(null);

  const init = () => {
    (function i(d, t) {
      const BASE_URL = 'https://app.chatwoot.com';
      const g = d.createElement(t),
        s = d.getElementsByTagName(t)[0];
      g.src = `${BASE_URL}/packs/js/sdk.js`;
      g.defer = true;
      g.async = true;
      s.parentNode.insertBefore(g, s);
      g.onload = function r() {
        window.chatwootSDK.run({
          websiteToken: getEnv('REACT_APP_CHAT_WIDGET_TOKEN'),
          baseUrl: BASE_URL,
        });
      };
    })(document, 'script');
  };

  useEffect(() => {
    window.chatwootSettings = {
      hideMessageBubble: true,
      position: theme.direction === 'rtl' ? 'right' : 'left',
      locale: getEnv('REACT_APP_LANGUAGE'),
      type: 'standard',
    };

    init();
  }, []);

  const toggleChatwoot = () => {
    window.$chatwoot.toggle();
  };

  useOnClickOutside(ref, (event) => {
    if (
      window.$chatwoot.isOpen &&
      !event.target.className.includes('chatwootToggler')
    ) {
      toggleChatwoot();
    }
  });

  useEffect(() => {
    const widgetHolder = document.querySelector('.woot-widget-holder');
    ref.current = widgetHolder;

    if (isSidebarMenuExpanded) widgetHolder?.classList?.add('expanded-menu');
    else widgetHolder?.classList?.remove('expanded-menu');
  }, [isSidebarMenuExpanded, window.$chatwoot?.hasLoaded]);

  return (
    <StyledChatwoot
      className='chatwoot'
      isSidebarMenuExpanded={isSidebarMenuExpanded}
    >
      <UiButton
        className='chatwootToggler'
        startIcon={
          <UiIcon
            className='chatwootToggler'
            icon='ri-chat-smile-line'
            color='#ffffff'
          />
        }
        onClick={toggleChatwoot}
      >
        <span className='text chatwootToggler'>{t('common:onlineHelp')}</span>
      </UiButton>
    </StyledChatwoot>
  );
}
